import { FILTER_CONFIG_NAMES } from './DataConstants';

export const getMeterFilterConfig = ({ filters }: { filters: any }) => {
	return [filters[FILTER_CONFIG_NAMES.LOCATION], filters[FILTER_CONFIG_NAMES.METER_TYPE]].filter(
		Boolean
	);
};
